const Ribbon = () => {
    const template = `
    <div id="ribbon" class="ribbon content">
        &nbsp;
    </div> 
  `;

    return template;
};

export default Ribbon;